$(document).ready(function(){

	function aboutUsTabs(){
		var navigationTabs = [];
		var tabs = [];

		$(".about-us-navigation ul li").map(function(i, e){
			navigationTabs.push($(e));
			$(this).attr("data-index", i);
		});

		$(".about-us-tabs .about-us-tab").map(function(i, e){
			tabs.push($(e));
			$(this).attr("data-index", i);
		});

		$(navigationTabs[0]).addClass("active");
		$(tabs[0]).addClass("active");

		$(".about-us-navigation ul li").on("click", function(e){
			e.preventDefault();
			var index = $(this).data("index");
			$(".about-us-navigation ul li").removeClass("active");
			$(".about-us-tabs .about-us-tab").removeClass("active");
			$(this).addClass("active");
			$(tabs[index]).addClass("active");
		});

		function hashTabs(){
			var hash = window.location.hash.substr(1);

			if(hash != ""){
				$(".about-us-tabs .about-us-tab").removeClass("active");
				$(".about-us-navigation ul li").removeClass("active");
				$(tabs[hash]).addClass("active");
				$(navigationTabs[hash]).addClass("active");
			}
		}

		hashTabs();

		$(".secondary-navigation .dropdown li").on("click", function(){
			setTimeout(hashTabs, 100);
		});

		$(".mobile-dropdown ul li").on("click", function(){
			setTimeout(hashTabs, 100);
		});

	}

	aboutUsTabs();

});


// WEBPACK FOOTER //
// src/js/bundle/about-us.js